import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Page, PageHeader } from '../ui'
import { SignatureReviewView } from '../components/views/signatureReviewView'

function SignatureReview() {
    return (
        <div className="signatureReview">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Sentinel Tools" title="Signature Review" intro="Review captured signatures and accept or reject them before documents are released." />
                    <SignatureReviewView />
                </Page>
            </MainView>
        </div>
    )
}

export default SignatureReview
